/*
 * Calculadora compacta na página de produto (card t_f144ed2f), terceira
 * etapa da calculadora aprovada pelo Gus (opção A).
 *
 * A conta NÃO mora aqui: é WillCalculadora.calcular (will-calculadora-motor.js).
 * A cor é a que JÁ está marcada no formulário da página — este widget não tem
 * seletor de cor próprio; troca de cor recarrega a página (link real em
 * will-dobra-produto.liquid), então basta ler `data-cor-atual` uma vez.
 *
 * Este arquivo DUPLICA de propósito um punhado pequeno de funções de
 * assets/will-calculadora-pagina.js (marcadas abaixo com "fonte:") em vez de
 * importar aquele arquivo — ele já foi aprovado e testado num card anterior,
 * e qualquer edição nele arrisca regressão. Ver comentário do snippet
 * will-calculadora-compacta.liquid.
 *
 * TROCAR UM CAMPO DEPOIS DE CALCULAR esconde o resultado e pede novo
 * "Calcular" — mesma regra da página.
 */
(function () {
  'use strict';

  var raiz = document.getElementById('will-calculadora-compacta');
  if (!raiz || typeof WillCalculadora === 'undefined') return;

  var W = WillCalculadora;
  var PREFIXO_POR_DEMAO = 'por demão';

  function $(id) { return document.getElementById(id); }

  var el = {
    area: $('wcc-area'),
    naoSei: $('wcc-nao-sei'),
    medidas: $('wcc-medidas'),
    largura: $('wcc-largura'),
    altura: $('wcc-altura'),
    medidasResultado: $('wcc-medidas-resultado'),
    demaosCaixa: $('wcc-demaos-caixa'),
    demaos: $('wcc-demaos'),
    calcular: $('wcc-calcular'),
    aviso: $('wcc-aviso'),
    resultado: $('wcc-resultado'),
    resCor: $('wcc-res-cor'),
    resCombinacao: $('wcc-res-combinacao'),
    resCobertura: $('wcc-res-cobertura'),
    resPrecoCheio: $('wcc-res-preco-cheio'),
    resPreco: $('wcc-res-preco'),
    resDesconto: $('wcc-res-desconto'),
    carrinho: $('wcc-carrinho'),
    carrinhoStatus: $('wcc-carrinho-status'),
    whatsapp: $('wcc-whatsapp'),
  };

  var handle = raiz.getAttribute('data-handle');
  var corAtual = raiz.getAttribute('data-cor-atual') || null;
  var temCor = raiz.getAttribute('data-tem-cor') === 'true';
  var numeroWhatsapp = (raiz.getAttribute('data-whatsapp') || '').replace(/\D/g, '');

  // Estado
  var linhasProduto = [];
  var dadosProduto = null;
  var precosCorAtual = {};
  var variantesPorEmbalagem = {};
  var ultimo = null; // { area, demaos, resultado } do último cálculo ok

  var formatoReal = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var formatoNumero = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });

  // fonte: assets/will-calculadora-pagina.js (reais, m2)
  function reais(centavos) { return formatoReal.format(centavos / 100); }
  function m2(n) { return formatoNumero.format(n) + ' m²'; }

  // fonte: assets/will-calculadora-pagina.js (embalagemVirgula)
  function embalagemVirgula(texto) {
    return String(texto).replace(/(\d+)\.(\d+)/g, '$1,$2');
  }

  // fonte: assets/will-calculadora-pagina.js (lerNumero)
  function lerNumero(texto) {
    var t = String(texto || '').trim().replace(/\s/g, '');
    if (t === '') return NaN;
    if (t.indexOf(',') !== -1) t = t.replace(/\./g, '').replace(',', '.');
    if (!/^\d*\.?\d+$|^\d+\.$/.test(t)) return NaN;
    return Number(t);
  }

  // fonte: assets/will-calculadora-pagina.js (chaveQuantidade) — chave de
  // casamento embalagem da tabela <-> variante da loja: "20kg", "3.6l".
  function chaveQuantidade(texto) {
    var m = String(texto || '').match(/(\d+(?:[.,]\d+)?)\s*(ml|l|kg)(?![a-z])/i);
    if (!m) return null;
    var n = parseFloat(m[1].replace(',', '.'));
    var u = m[2].toLowerCase();
    if (u === 'ml') { n = n / 1000; u = 'l'; }
    return Math.round(n * 1000) / 1000 + u;
  }

  // fonte: assets/will-calculadora-pagina.js (ehPorDemao, adaptada para 1 produto)
  function ehPorDemao(embalagem) {
    return linhasProduto.some(function (l) {
      return l.embalagem_display === embalagem &&
        String(l.base_rendimento).normalize('NFC').toLowerCase().indexOf(PREFIXO_POR_DEMAO.normalize('NFC').toLowerCase()) === 0;
    });
  }

  var MENSAGEM = {
    sem_cor_selecionada: 'Não conseguimos achar o preço desta cor agora. Recarregue a página ou fale com a gente no WhatsApp.',
    produto_sem_tabela: 'Não conseguimos fazer a conta deste produto agora. Fale com a gente no WhatsApp.',
    linhas_de_varios_produtos: 'Não conseguimos fazer a conta deste produto agora. Fale com a gente no WhatsApp.',
    tabela_ambigua: 'Não conseguimos fazer a conta deste produto agora. Fale com a gente no WhatsApp.',
    area_invalida: 'Informe a área em m², com um número maior que zero.',
    numero_demaos_obrigatorio: 'Escolha quantas demãos.',
    nenhuma_embalagem_elegivel: 'Nesta cor, nenhuma embalagem à venda serve para essa escolha. Tente outra opção ou fale com a gente no WhatsApp.',
    preco_invalido: 'O preço desta cor não chegou certo da loja. Recarregue a página ou fale com a gente no WhatsApp.',
  };

  /*
   * Monta, para a cor JÁ escolhida no formulário (data-cor-atual), o mapa
   * embalagem_display -> variante. Versão enxuta de montarVariantes() de
   * will-calculadora-pagina.js: aquela junta TODAS as cores do produto (a
   * página deixa escolher); aqui só interessa a cor corrente.
   */
  function montarPrecos() {
    var opcaoTamanho = null;
    for (var i = 0; i < dadosProduto.options.length; i++) {
      if (/tamanho/i.test(dadosProduto.options[i].name)) opcaoTamanho = i;
    }
    var embalagens = [];
    linhasProduto.forEach(function (l) {
      if (embalagens.indexOf(l.embalagem_display) === -1) embalagens.push(l.embalagem_display);
    });
    var chavePorEmbalagem = {};
    linhasProduto.forEach(function (l) {
      chavePorEmbalagem[l.embalagem_display] = chaveQuantidade(l.quantidade + ' ' + l.unidade_quantidade);
    });

    dadosProduto.variants.forEach(function (v) {
      var opcoes = v.options || [];
      var embalagem = null;
      if (opcaoTamanho === null) {
        if (dadosProduto.variants.length === 1 && embalagens.length === 1) embalagem = embalagens[0];
      } else {
        var chave = chaveQuantidade(opcoes[opcaoTamanho]);
        for (var e = 0; e < embalagens.length; e++) {
          if (chavePorEmbalagem[embalagens[e]] === chave) { embalagem = embalagens[e]; break; }
        }
      }
      if (!embalagem || !v.available) return;

      if (temCor) {
        var partesCor = [];
        for (var o = 0; o < opcoes.length; o++) if (o !== opcaoTamanho) partesCor.push(opcoes[o]);
        var cor = partesCor.join(' / ');
        if (cor !== corAtual) return;
      }

      precosCorAtual[embalagem] = v.price;
      variantesPorEmbalagem[embalagem] = v;
    });
  }

  function montarDemaos() {
    var demaos = W.demaosDisponiveis(linhasProduto);
    el.demaos.innerHTML = '';
    if (demaos.length) {
      var vazio = document.createElement('option');
      vazio.value = '';
      vazio.textContent = 'Escolha';
      el.demaos.appendChild(vazio);
      demaos.forEach(function (n) {
        var o = document.createElement('option');
        o.value = String(n);
        o.textContent = n === 1 ? '1 demão' : n + ' demãos';
        el.demaos.appendChild(o);
      });
    }
    el.demaosCaixa.hidden = demaos.length === 0;
  }

  function areaAtual() { return lerNumero(el.area.value); }
  function demaosAtual() {
    if (el.demaosCaixa.hidden) return null;
    var v = el.demaos.value;
    return v === '' ? NaN : Number(v);
  }

  function invalidar() {
    ultimo = null;
    el.resultado.hidden = true;
    el.aviso.hidden = true;
    el.aviso.textContent = '';
    el.carrinhoStatus.hidden = true;
    el.carrinhoStatus.textContent = '';
  }

  function avisar(texto) {
    el.aviso.textContent = texto;
    el.aviso.hidden = false;
  }

  function aoMudarCampo() { invalidar(); }

  function calcular() {
    invalidar();
    var area = areaAtual();
    var demaos = demaosAtual();
    var entrada = {
      linhasProduto: linhasProduto,
      areaM2: area,
      numeroDemaos: demaos === null || isNaN(demaos) ? null : demaos,
      precos: precosCorAtual,
    };
    var r = W.calcular(entrada);
    if (!r.ok) {
      avisar(MENSAGEM[r.motivo] || MENSAGEM.produto_sem_tabela);
      return;
    }
    ultimo = { area: area, demaos: entrada.numeroDemaos, resultado: r };
    mostrarResultado();
    consultarPrecoComDesconto(ultimo);
  }

  function descreverCombinacao(r) {
    return r.combinacao.map(function (c) {
      return c.quantidade_embalagens + 'x ' + embalagemVirgula(c.embalagem_display);
    });
  }

  // Mesmo texto/formatação de mostrarResultado() em will-calculadora-pagina.js:
  // a tela mostra sempre o rendimento PUBLICADO, nunca a cobertura interna
  // que o motor usou na conta.
  function mostrarResultado() {
    var u = ultimo;
    var r = u.resultado;

    if (temCor) {
      el.resCor.textContent = 'na cor ' + corAtual;
      el.resCor.hidden = false;
    } else {
      el.resCor.hidden = true;
    }

    el.resCombinacao.innerHTML = '';
    var somaFixa = 0;
    var somaTaxa = 0;
    r.combinacao.forEach(function (c) {
      var li = document.createElement('li');
      var forte = document.createElement('strong');
      forte.textContent = c.quantidade_embalagens + 'x ' + embalagemVirgula(c.embalagem_display);
      li.appendChild(forte);
      var taxa = ehPorDemao(c.embalagem_display);
      var detalhe = document.createElement('span');
      detalhe.textContent = taxa
        ? 'rende até ' + m2(c.cobertura_publicada_m2_cada) + ' por demão cada'
        : 'rende ' + m2(c.cobertura_publicada_m2_cada) + ' cada';
      li.appendChild(detalhe);
      el.resCombinacao.appendChild(li);
      if (taxa) somaTaxa += c.quantidade_embalagens * c.cobertura_publicada_m2_cada;
      else somaFixa += c.quantidade_embalagens * c.cobertura_publicada_m2_cada;
    });

    // C4 (revisão t_6205af6c): mesma correção de will-calculadora-pagina.js —
    // "Rende {somaTaxa} por demão" somava TODAS as demãos (ex.: 126 m² para
    // 3 demãos de 42 m² cada) ao lado de "3 demãos", parecendo 3x mais do
    // que realmente rende. "Cobre até X m² em N demãos" usa X = cobertura
    // de UMA demão só (somaTaxa / demaos) — nenhum número novo.
    var partes = [];
    if (somaFixa > 0) partes.push('Cobre ' + m2(somaFixa));
    if (somaTaxa > 0) {
      var coberturaPorDemaoUnica = u.demaos ? somaTaxa / u.demaos : somaTaxa;
      partes.push(
        'Cobre até ' + m2(coberturaPorDemaoUnica) + (u.demaos
          ? ' em ' + u.demaos + (u.demaos === 1 ? ' demão' : ' demãos')
          : ' por demão')
      );
    }
    el.resCobertura.textContent = partes.join(' · ');

    el.resPreco.textContent = reais(r.custoTotalCentavos);

    // Preço com desconto ainda não chegou (ou nunca chega): riscado e nome do
    // desconto ficam ocultos até consultarPrecoComDesconto() resolver.
    el.resPrecoCheio.hidden = true;
    el.resDesconto.hidden = true;

    el.whatsapp.href = linkWhatsapp(u);

    el.resultado.hidden = false;
    el.resultado.focus({ preventScroll: true });
  }

  // Preço final: o que a Shopify devolveu para esta combinação, se já chegou
  // a tempo; senão o preço de TABELA (o motor calculou, sem desconto).
  function precoFinal(u) {
    return typeof u.precoFinalCentavos === 'number' ? u.precoFinalCentavos : u.resultado.custoTotalCentavos;
  }

  // Mesmo tom de linkWhatsapp() em will-calculadora-pagina.js.
  function linkWhatsapp(u) {
    var linhas = ['Olá! Fiz a conta na calculadora do site e quero esse pedido:'];
    linhas.push('');
    linhas.push('Produto: ' + (dadosProduto ? dadosProduto.title : handle));
    if (temCor) linhas.push('Cor: ' + corAtual);
    linhas.push('Área: ' + m2(u.area) + (u.demaos ? ' (' + u.demaos + (u.demaos === 1 ? ' demão' : ' demãos') + ')' : ''));
    linhas.push('Embalagens: ' + descreverCombinacao(u.resultado).join(' + '));
    linhas.push('Valor na calculadora: ' + reais(precoFinal(u)));
    linhas.push('');
    linhas.push('Pode confirmar valor e disponibilidade?');
    return 'https://wa.me/' + numeroWhatsapp + '?text=' + encodeURIComponent(linhas.join('\n'));
  }

  /*
   * Mesma lógica de will-calculadora-pagina.js: consulta em paralelo o preço
   * FINAL da mesma combinação na Shopify, sem bloquear a UI. Se `ultimo`
   * mudar (invalidar() ou novo cálculo) antes da resposta chegar, a resposta
   * atrasada é ignorada.
   */
  function consultarPrecoComDesconto(u) {
    if (typeof WillCalculadoraDesconto === 'undefined') return;
    var montado = itensDoCarrinho(u);
    if (montado.faltando.length) return; // sem variante casada: nem tenta
    var linhas = WillCalculadoraDesconto.paraLinhasGid(montado.itens);
    WillCalculadoraDesconto.consultarDesconto(linhas).then(function (r) {
      if (ultimo !== u) return;
      if (!r.ok) return; // mantém o preço de tabela, sem riscado, sem erro visível
      u.precoFinalCentavos = r.totalCentavos;
      u.descontos = r.descontos;
      mostrarDesconto(u);
    });
  }

  function mostrarDesconto(u) {
    // O preço na tela sempre reflete o total que a Shopify devolveu (o mesmo
    // que /cart.js cobraria), tenha ou não desconto — é o que garante que
    // bate exatamente com o carrinho real.
    el.resPreco.textContent = reais(u.precoFinalCentavos);
    el.whatsapp.href = linkWhatsapp(u);

    if (!u.descontos || u.descontos.length === 0) {
      el.resPrecoCheio.hidden = true;
      el.resDesconto.hidden = true;
      return;
    }
    el.resPrecoCheio.querySelector('s').textContent = reais(u.resultado.custoTotalCentavos);
    el.resPrecoCheio.hidden = false;
    el.resDesconto.textContent = u.descontos.map(function (d) { return d.titulo; }).join(', ');
    el.resDesconto.hidden = false;
  }

  function itensDoCarrinho(u) {
    var itens = [];
    var faltando = [];
    u.resultado.combinacao.forEach(function (c) {
      var v = variantesPorEmbalagem[c.embalagem_display];
      if (!v) faltando.push(c.embalagem_display);
      else itens.push({ id: v.id, quantity: c.quantidade_embalagens });
    });
    return { itens: itens, faltando: faltando };
  }

  function statusCarrinho(texto, link) {
    el.carrinhoStatus.textContent = texto;
    if (link) {
      el.carrinhoStatus.appendChild(document.createTextNode(' '));
      var a = document.createElement('a');
      a.href = (window.routes && window.routes.cart_url) || '/cart';
      a.textContent = 'Ver carrinho';
      el.carrinhoStatus.appendChild(a);
    }
    el.carrinhoStatus.hidden = false;
  }

  function adicionarAoCarrinho() {
    if (!ultimo) return;
    var montado = itensDoCarrinho(ultimo);
    if (montado.faltando.length) {
      statusCarrinho('Não achamos na loja a embalagem ' + montado.faltando.join(', ') +
        ' nesta cor. Nada foi adicionado. Fale com a gente no WhatsApp.');
      return;
    }
    el.carrinho.disabled = true;
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(base + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: montado.itens, sections: 'cart-icon-bubble' }),
    })
      .then(function (resp) {
        return resp.json().then(function (corpo) { return { ok: resp.ok, corpo: corpo }; });
      })
      .then(function (r) {
        if (!r.ok) {
          statusCarrinho('Não deu para adicionar: ' + (r.corpo.description || r.corpo.message || 'erro da loja') + '.');
          return;
        }
        var bolha = document.getElementById('cart-icon-bubble');
        var html = r.corpo.sections && r.corpo.sections['cart-icon-bubble'];
        if (bolha && html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var novo = doc.querySelector('.shopify-section');
          if (novo) bolha.innerHTML = novo.innerHTML;
        }
        statusCarrinho('Adicionado ao carrinho.', true);
      })
      .catch(function () {
        statusCarrinho('Não deu para adicionar agora. Verifique a internet e tente de novo.');
      })
      .then(function () { el.carrinho.disabled = false; });
  }

  function atualizarMedidas() {
    var l = lerNumero(el.largura.value);
    var a = lerNumero(el.altura.value);
    if (l > 0 && a > 0) {
      var area = Math.round(l * a * 10) / 10;
      el.medidasResultado.textContent = '= ' + m2(area);
      el.area.value = formatoNumero.format(area).replace(/\./g, '');
      aoMudarCampo();
    } else {
      el.medidasResultado.textContent = '';
    }
  }

  function ligar() {
    el.area.addEventListener('input', aoMudarCampo);
    el.demaos.addEventListener('change', aoMudarCampo);
    el.largura.addEventListener('input', atualizarMedidas);
    el.altura.addEventListener('input', atualizarMedidas);
    el.naoSei.addEventListener('click', function () {
      var abrir = el.medidas.hidden;
      el.medidas.hidden = !abrir;
      el.naoSei.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      if (abrir) el.largura.focus();
    });
    el.calcular.addEventListener('click', calcular);
    el.carrinho.addEventListener('click', adicionarAoCarrinho);
  }

  function carregarProduto() {
    var raizLoja = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(raizLoja + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (dados) {
        if (!dados) { raiz.hidden = true; return; }
        dadosProduto = dados;
        montarPrecos();
        montarDemaos();
        ligar();
      })
      .catch(function () { raiz.hidden = true; });
  }

  // O widget nasce visível; só some (`raiz.hidden = true`) se a tabela de
  // rendimento ou os dados do produto não carregarem — normalmente ele só é
  // incluído nos 20 templates certos, mas a rede pode falhar, e um cartão de
  // calculadora quebrado é pior do que nenhum.
  function carregar() {
    fetch(raiz.getAttribute('data-rendimentos'))
      .then(function (r) { return r.json(); })
      .then(function (tabela) {
        linhasProduto = (tabela.linhas || []).filter(function (l) { return l.handle_loja === handle; });
        if (!linhasProduto.length) { raiz.hidden = true; return; }
        return carregarProduto();
      })
      .catch(function () { raiz.hidden = true; });
  }

  carregar();
})();
